export default __webpack_public_path__ + "static/media/lines-bg.7dd751b2.svg";